import type { FC } from 'react';
import { memo } from 'react';

import { NodePanelProps } from '../../types';
import NlpForm from './form';
import type { NlpExtractNodeType } from './types';

const Panel: FC<NodePanelProps<NlpExtractNodeType>> = ({
  id,
  formRef,
  data,
  initialValue,
  node_id,
  readonly,
}) => {
  return (
    <div className="px-4">
      <NlpForm
        readonly={readonly}
        node_id={node_id}
        initialValue={initialValue}
        ref={formRef}
      />
    </div>
  );
};

export default memo(Panel);
